import { AfterViewInit, ChangeDetectionStrategy, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject, combineLatest, Observable, Subject } from 'rxjs';
import { map, shareReplay, take, takeUntil } from 'rxjs/operators';
import { User } from '../../core/user';
import { CreateUserFormComponent } from './create-user-form.component';

@Component({
  templateUrl: './create.component.html',
  styleUrls: ['./create.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class BusinessUserCreateComponent implements OnInit, AfterViewInit, OnDestroy {
  returnUrl: string;
  isCreatingUser$$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  @ViewChild('createForm') createFormComponent: CreateUserFormComponent;

  private _destroy$$ = new Subject<void>();
  accountGroupId$: Observable<string>;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    this.accountGroupId$ = this.route.queryParamMap.pipe(
      map((params) => params.get('accountGroupId')),
      shareReplay(1),
    );

    this.returnUrl = '/bc-admin';
    const from$ = this.route.queryParamMap.pipe(map((params) => params.get('from')));
    combineLatest([this.accountGroupId$, from$])
      .pipe(takeUntil(this._destroy$$))
      .subscribe(([accountGroupId, from]) => {
        if (from === 'account-details') {
          this.returnUrl = `businesses/accounts/${accountGroupId}/details`;
        }
      });
  }

  ngAfterViewInit(): void {
    this.createFormComponent
      .isCreatingUser()
      .pipe(takeUntil(this._destroy$$))
      .subscribe((isLoading) => this.isCreatingUser$$.next(isLoading));
  }

  ngOnDestroy(): void {
    this._destroy$$.next();
    this._destroy$$.complete();
  }

  navigateAfterUserCreation(user: User): void {
    const url = user.userId ? '/bc-admin/users/' + user.userId + '/permissions/' : '';
    this.accountGroupId$
      .pipe(take(1))
      .subscribe((accountGroupId: string) =>
        accountGroupId ? this.router.navigateByUrl(this.returnUrl) : this.router.navigateByUrl(url),
      );
  }

  cancel(): void {
    this.router.navigateByUrl(this.returnUrl);
  }

  createUser(): void {
    this.createFormComponent.createUser();
  }
}
